<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Produto</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action @submit.prevent>

                <div class="copy-product-box">
                  <label>Copiar dados de um produto existente <span class="text-muted">(opcional)</span>:</label>
                  <div class="d-flex flex-wrap" style="gap: 10px;">
                    <div class="input-group" style="flex: 1 1 240px;">
                      <div class="input-group-prepend">
                        <span class="input-group-text">PAT-</span>
                      </div>
                      <input
                        type="tel"
                        class="form-control"
                        v-model="copyBarcodeSuffix"
                        placeholder="Digite ou escaneie o patrimônio a copiar"
                        @keyup.enter="copyFromBarcode"
                      />
                      <div class="input-group-append">
                        <button type="button" class="btn btn-outline-primary" title="Pesquisar" @click="copyFromBarcode">
                          <i class="fa fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-outline-secondary" title="Escanear com a câmera" @click="openScanner('copy')">
                          <i class="fa fa-camera"></i>
                        </button>
                      </div>
                    </div>
                    <div class="model-list-wrapper">
                      <button type="button" class="btn btn-outline-secondary" @click="showModelList = !showModelList">
                        Ver modelos cadastrados
                        <i class="fa" :class="showModelList ? 'fa-caret-up' : 'fa-caret-down'"></i>
                      </button>
                      <div v-if="showModelList" class="model-list-dropdown">
                        <div class="model-list-header">Modelos cadastrados no estoque</div>
                        <div
                          v-for="m in modelStockSummary"
                          :key="m.id"
                          class="model-list-item"
                          @click="selectModel(m)"
                        >
                          <div>
                            <div>{{ m.name }}</div>
                            <small class="text-muted">{{ m.category_name }}</small>
                          </div>
                          <span class="text-muted">{{ m.count }} unid.</span>
                        </div>
                      </div>
                    </div>
                    <button type="button" class="btn btn-outline-danger" title="Limpar dados copiados" @click="clearCopiedData">
                      <i class="fa fa-eraser"></i> Limpar
                    </button>
                  </div>
                  <small class="text-muted d-block mt-2">
                    Encontre um produto para copiar seus dados — os campos abaixo são preenchidos automaticamente e você pode ajustar antes de salvar.
                  </small>
                </div>

                <hr class="section-divider" /> 

                <h6 class="section-title">Identificação</h6>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>Descrição:</label>
                    <textarea class="form-control" v-model="product.description" rows="2"></textarea>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label><span class="required">*</span> Patrimônio (código de identificação):</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">PAT-</span>
                      </div>
                      <input
                        type="tel"
                        class="form-control"
                        v-model="barcodeSuffix"
                        placeholder="Digite ou escaneie o código de patrimônio"
                      />
                      <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary" title="Escanear com a câmera" @click="openScanner('main')">
                          <i class="fa fa-camera"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="section-divider" />

                
                <h6 class="section-title">Classificação</h6>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label><span class="required">*</span> Categoria:</label>
                    <v-select
                      v-model="product.product_category_id"
                      :options="categories"
                      :reduce="(categories) => categories.id"
                      :label="'name'"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label><span class="required">*</span> Fabricante:</label>
                    <v-select
                      v-model="product.manufacturer_id"
                      :options="manufacturers"
                      :reduce="(manufacturers) => manufacturers.id"
                      :label="'name'"
                      @input="onManufacturerChange"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label><span class="required">*</span> Modelo:</label>
                    <v-select
                      v-model="product.product_model_id"
                      :options="filteredModels"
                      :reduce="(models) => models.id"
                      :label="'name'"
                    ></v-select>
                  </div>
                </div>

                <hr class="section-divider" />

                
                <h6 class="section-title">Aquisição</h6>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Fornecedor:</label>
                    <v-select
                      v-model="product.supplier_id"
                      :options="suppliers"
                      :reduce="(suppliers) => suppliers.id"
                      :label="'name'"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor de Compra:</label>
                    <input type="number" step="0.01" class="form-control" v-model="product.purchase_value" />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Data de Aquisição:</label>
                    <input type="date" class="form-control" v-model="product.purchase_date" />
                  </div>
                </div>

                <hr class="section-divider" />

               
                <h6 class="section-title">Localização e status</h6>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Cliente (localização atual):</label>
                    <v-select
                      v-model="product.current_client_id"
                      :options="clients"
                      :reduce="(clients) => clients.id"
                      :label="'company_name'"
                      @input="onClientChange"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Unidade (localização atual):</label>
                    <v-select
                      v-model="product.current_unit_id"
                      :options="filteredUnits"
                      :reduce="(units) => units.id"
                      :label="'name'"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label><span class="required">*</span> Status:</label>
                    <select v-model="product.status" class="form-control">
                      <option :value="1">Em estoque</option>
                      <option :value="2">Em uso</option>
                      <option :value="3">Manutenção</option>
                      <option :value="0">Baixado</option>
                    </select>
                  </div>
                </div>

                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/products" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="barcodeScannerModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Escanear Patrimônio</h5>
            <button type="button" class="close" data-dismiss="modal" @click="closeScanner">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div id="barcode-scanner-viewport" v-show="!useZxingScanner"></div>
            <video
              id="zxing-scanner-viewport"
              v-show="useZxingScanner"
              class="zxing-scanner-viewport"
              playsinline
              muted
              autoplay
            ></video>
            <p class="text-muted text-center mt-2 mb-0">
              Aproxime a câmera do código de barras do patrimônio e mantenha firme até focar.
            </p>
            <p v-if="scannerError" class="text-danger text-center mt-2 mb-0">{{ scannerError }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { Html5Qrcode, Html5QrcodeSupportedFormats, Html5QrcodeScannerState } from "html5-qrcode";
import { BrowserMultiFormatReader, DecodeHintType, BarcodeFormat, NotFoundException } from "@zxing/library";

function hasNativeBarcodeDetector() {
  if (typeof window === "undefined" || !("BarcodeDetector" in window)) {
    return false;
  }
  try {
    const detector = new window.BarcodeDetector({ formats: ["code_128"] });
    return !!detector;
  } catch (e) {
    return false;
  }
}

export default {
  name: "productAdd",
  data() {
    return {
      pageLoading: true,
      barcodeSuffix: "",
      copyFromProductId: "",
      copyBarcodeSuffix: "",
      showModelList: false,
      scannerTarget: "",
      scannerError: "",
      html5QrCode: null,
      useZxingScanner: false,
      zxingReader: null,
      zxingVideoElement: null,
      product: {
        description: "",
        barcode: "PAT-",
        product_category_id: "",
        manufacturer_id: "",
        product_model_id: "",
        supplier_id: "",
        purchase_value: "",
        purchase_date: "",
        status: "",
        current_client_id: "",
        current_unit_id: "",
      },
      categories: [],
      manufacturers: [],
      models: [],
      clients: [],
      suppliers: [],
      units: [],
      products: [],
    };
  },
  components: {
    vSelect,
  },
  watch: {
    barcodeSuffix: function (value) {
      this.product.barcode = "PAT-" + value;
    },
  },
  computed: {
    filteredModels: function () {
      const self = this;
      if (!self.product.manufacturer_id) return [];
      return self.models.filter(
        (m) => m.manufacturer_id == self.product.manufacturer_id
      );
    },
    filteredUnits: function () {
      const self = this;
      if (!self.product.current_client_id) return [];
      return self.units.filter(
        (u) => u.client_id == self.product.current_client_id
      );
    },
    modelStockSummary: function () {
      const self = this;
      return self.models.map((m) => ({
        id: m.id,
        name: m.name,
        manufacturer_id: m.manufacturer_id,
        category_name: (self.categories.find((c) => c.id == m.product_category_id) || {}).name || "",
        count: self.products.filter((p) => p.product_model_id == m.id).length,
      }));
    },
  },
  methods: {
    onManufacturerChange: function () {
      this.product.product_model_id = "";
    },

    onClientChange: function () {
      this.product.current_unit_id = "";
    },

    onCopyFromProductChange: function () {
      const self = this;
      const source = self.products.find((p) => p.id == self.copyFromProductId);
      if (!source) return;

      self.product.description = source.description;
      self.product.product_category_id = source.product_category_id;
      self.product.manufacturer_id = source.manufacturer_id;
      self.product.product_model_id = source.product_model_id;
      self.product.supplier_id = source.supplier_id;
      self.product.purchase_value = source.purchase_value;
      self.product.purchase_date = source.purchase_date;
      self.product.status = source.status;
      self.product.current_client_id = source.current_client_id;
      self.product.current_unit_id = source.current_unit_id;
    },

    clearCopiedData: function () {
      const self = this;

      self.copyFromProductId = "";
      self.copyBarcodeSuffix = "";
      self.showModelList = false;

      self.product.description = "";
      self.product.product_category_id = "";
      self.product.manufacturer_id = "";
      self.product.product_model_id = "";
      self.product.supplier_id = "";
      self.product.purchase_value = "";
      self.product.purchase_date = "";
      self.product.status = "";
      self.product.current_client_id = "";
      self.product.current_unit_id = "";
    },

    selectModel: function (m) {
      const self = this;
      self.product.manufacturer_id = m.manufacturer_id;
      self.product.product_model_id = m.id;

      const existingProduct = self.products.find((p) => p.product_model_id == m.id);
      if (existingProduct) {
        self.product.product_category_id = existingProduct.product_category_id;
      }

      self.showModelList = false;

      self.$message(
        "Modelo selecionado",
        `Dados do modelo "${m.name}" copiados. Você pode ajustar os campos antes de salvar.`,
        "success"
      );
    },

    copyFromBarcode: function () {
      const self = this;
      const barcode = "PAT-" + self.copyBarcodeSuffix;
      const found = self.products.find((p) => p.barcode === barcode);

      if (!found) {
        self.$message(null, "Nenhum produto encontrado com esse patrimônio", "error");
        return;
      }

      self.copyFromProductId = found.id;
      self.onCopyFromProductChange();
      self.copyBarcodeSuffix = "";

      self.$message(
        "Produto encontrado",
        `Dados copiados de "${found.product_model ? found.product_model.name : barcode}". Role a página para continuar o cadastro.`,
        "success"
      );
    },

    openScanner: function (target) {
      const self = this;
      self.scannerTarget = target;
      self.scannerError = "";
      self.useZxingScanner = !hasNativeBarcodeDetector();

      $("#barcodeScannerModal").modal("show");

      self.$nextTick(() => {
        if (self.useZxingScanner) {
          self.startZxingScanner();
        } else {
          self.startHtml5QrcodeScanner();
        }
      });

      $("#barcodeScannerModal").off("hidden.bs.modal").on("hidden.bs.modal", function () {
        self.pauseScanner();
      });
    },

    startHtml5QrcodeScanner: function () {
      const self = this;

      if (self.html5QrCode) {
        const state = self.html5QrCode.getState();
        if (state === Html5QrcodeScannerState.PAUSED) {
          self.html5QrCode.resume();
          self.applyHtml5QrcodeAutoZoom();
          return;
        }
        if (state === Html5QrcodeScannerState.SCANNING) {
          self.applyHtml5QrcodeAutoZoom();
          return;
        }
        self.html5QrCode = null;
      }

      self.html5QrCode = new Html5Qrcode("barcode-scanner-viewport", {
        formatsToSupport: [
          Html5QrcodeSupportedFormats.CODE_128,
          Html5QrcodeSupportedFormats.EAN_13,
          Html5QrcodeSupportedFormats.EAN_8,
          Html5QrcodeSupportedFormats.UPC_A,
        ],
        useBarCodeDetectorIfSupported: true,
        verbose: false,
      });

      self.html5QrCode
        .start(
          { facingMode: "environment" },
          {
            fps: 15,
            qrbox: { width: 300, height: 120 },
            disableFlip: true,
            videoConstraints: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 },
            },
          },
          (decodedText) => self.onScanSuccess(decodedText),
          () => {}
        )
        .then(() => {
          if (self.html5QrCode) {
            self.html5QrCode
              .applyVideoConstraints({ advanced: [{ focusMode: "continuous" }] })
              .catch(() => {});
          }
          self.applyHtml5QrcodeAutoZoom();
        })
        .catch((err) => {
          self.scannerError = "Não foi possível acessar a câmera: " + err;
        });
    },

    applyHtml5QrcodeAutoZoom: function () {
      const self = this;
      if (!self.html5QrCode) return;
      try {
        const zoom = self.html5QrCode.getRunningTrackCameraCapabilities().zoomFeature();
        if (zoom.isSupported()) {
          const target = zoom.min() + (zoom.max() - zoom.min()) * 0.35;
          zoom.apply(target).catch(() => {});
        }
      } catch (e) {}
    },

    startZxingScanner: function () {
      const self = this;

      if (self.zxingReader && self.zxingVideoElement && self.zxingVideoElement.srcObject) {
        self.zxingReader.decodeContinuously(self.zxingVideoElement, (result, err) =>
          self.handleZxingResult(result, err)
        );
        self.applyZxingAutoZoom();
        return;
      }

      const hints = new Map();
      hints.set(DecodeHintType.POSSIBLE_FORMATS, [
        BarcodeFormat.CODE_128,
        BarcodeFormat.EAN_13,
        BarcodeFormat.EAN_8,
        BarcodeFormat.UPC_A,
      ]);
      hints.set(DecodeHintType.TRY_HARDER, true);

      self.zxingReader = new BrowserMultiFormatReader(hints);

      self.zxingReader
        .decodeFromConstraints(
          {
            audio: false,
            video: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 },
            },
          },
          "zxing-scanner-viewport",
          (result, err) => self.handleZxingResult(result, err)
        )
        .then(() => {
          self.zxingVideoElement = document.getElementById("zxing-scanner-viewport");
          self.applyZxingAutoZoom();
        })
        .catch((err) => {
          self.scannerError = "Não foi possível acessar a câmera: " + err;
        });
    },

    handleZxingResult: function (result, err) {
      const self = this;
      if (result) {
        self.onScanSuccess(result.getText());
        return;
      }
      if (err && !(err instanceof NotFoundException)) {
        self.scannerError = "Erro ao ler o código de barras: " + err;
      }
    },

    applyZxingAutoZoom: function () {
      const self = this;
      if (!self.zxingReader || !self.zxingReader.stream) return;
      const track = self.zxingReader.stream.getVideoTracks()[0];
      if (!track || typeof track.getCapabilities !== "function") return;
      try {
        const capabilities = track.getCapabilities();
        if (!capabilities.zoom) return;
        const target = capabilities.zoom.min + (capabilities.zoom.max - capabilities.zoom.min) * 0.35;
        track.applyConstraints({ advanced: [{ zoom: target }] }).catch(() => {});
      } catch (e) {}
    },

    onScanSuccess: function (decodedText) {
      const self = this;
      const value = (decodedText || "").trim().replace(/^PAT-/i, "");

      if (self.scannerTarget === "main") {
        self.barcodeSuffix = value;
      } else if (self.scannerTarget === "copy") {
        self.copyBarcodeSuffix = value;
      }

      self.closeScanner();

      if (self.scannerTarget === "copy") {
        self.copyFromBarcode();
      }
    },

    pauseScanner: function () {
      const self = this;
      if (self.html5QrCode && self.html5QrCode.getState() === Html5QrcodeScannerState.SCANNING) {
        self.html5QrCode.pause(true);
      }
      if (self.zxingReader) {
        self.zxingReader.stopContinuousDecode();
      }
    },

    stopScanner: function () {
      const self = this;
      if (self.html5QrCode) {
        self.html5QrCode
          .stop()
          .then(() => self.html5QrCode.clear())
          .catch(() => {});
        self.html5QrCode = null;
      }
      if (self.zxingReader) {
        self.zxingReader.reset();
        self.zxingReader = null;
        self.zxingVideoElement = null;
      }
    },

    closeScanner: function () {
      $("#barcodeScannerModal").modal("hide");
      this.pauseScanner();
    },

    getProducts: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "products/?with[]=productModel")
        .then((response) => {
          self.products = response.data.data.map((p) => ({
            ...p,
            label: (p.product_model ? p.product_model.name : "Sem Modelo") + " — " + (p.barcode || "sem código"),
          }));
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getCategories: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "product_categories/?status=1")
        .then((response) => {
          self.categories = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getManufacturers: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "manufacturers/?status=1")
        .then((response) => {
          self.manufacturers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getModels: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "product_models/?status=1")
        .then((response) => {
          self.models = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getSuppliers: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "suppliers/?status=1")
        .then((response) => {
          self.suppliers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getClients: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "clients/?status=1")
        .then((response) => {
          self.clients = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUnits: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "client_units/?status=1")
        .then((response) => {
          self.units = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    save: function () {
      const self = this;

      if (!self.barcodeSuffix) {
        self.$message(null, "Digite o número do Patrimônio", "error");
        return;
      }

      let api = self.$store.state.api + "products";

      if (self.product.id) {
        api += "/" + self.product.id;
        self.product._method = "PUT";
      }

      axios
        .post(api, self.product)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/products");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getProduct: function (id) {
      const self = this;
      return axios
        .get(self.$store.state.api + "products/" + id)
        .then((response) => {
          self.product = response.data.data[0];
          self.barcodeSuffix = (self.product.barcode || "").replace(/^PAT-/, "");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },

  beforeDestroy() {
    this.stopScanner();
  },

  async mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.pageLoading = true;

    try {
      await Promise.all([
        self.getCategories(),
        self.getManufacturers(),
        self.getModels(),
        self.getSuppliers(),
        self.getClients(),
        self.getUnits(),
        self.getProducts(),
      ]);

      if (id) {
        await self.getProduct(id);
      }
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>

<style scoped>
.copy-product-box {
  background: rgba(79, 143, 247, 0.08);
  border: 1.5px dashed rgba(79, 143, 247, 0.4);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  position: relative;
}
.model-list-wrapper {
  position: relative;
}
.model-list-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  width: 340px;
  max-height: 280px;
  overflow-y: auto;
  background: #283046;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  z-index: 5;
  padding: 8px;
}
.model-list-header {
  padding: 8px 10px;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
}
.model-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 7px;
  cursor: pointer;
  color: #fff;
}
.model-list-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

body:not(.dark-layout) .model-list-dropdown {
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
}
body:not(.dark-layout) .model-list-header {
  color: #888;
}
body:not(.dark-layout) .model-list-item {
  color: inherit;
}
body:not(.dark-layout) .model-list-item:hover {
  background: #f2f4f8;
}
.section-title {
  font-weight: 600;
  margin-bottom: 14px;
}
.section-divider {
  margin: 22px 0;
}
#barcode-scanner-viewport {
  width: 100%;
  min-height: 250px;
}
.zxing-scanner-viewport {
  width: 100%;
  min-height: 250px;
  background: #000;
  object-fit: cover;
}
</style>